import React from 'react'
import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import StylesProvider from '@mui/styles/StylesProvider'
import { ThemeProvider } from 'styled-components'
import { Layout } from 'containers/Layout'
import { Notification, Sprite } from 'components/Common'
import { CentraTheme, GlobalStyle, MuiTheme } from 'components'
import 'moment/locale/ru'
import moment from 'moment'
import '@centra/centra-ui/dist/styles.css'
import { AppProvider } from '@centra/centra-ui'
import { GTM_CONTAINER_ID, NG_API_CLIENT } from 'services/api'
import { Router } from 'react-router'
import { history } from 'store/configureStore'

moment.locale('ru')

const App = () => {
  return (
    <AppProvider ngApiClient={NG_API_CLIENT} isAuthZone gtmContainerId={GTM_CONTAINER_ID}>
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={MuiTheme}>
          <StylesProvider injectFirst>
            <ThemeProvider theme={CentraTheme}>
              <Notification />
              <GlobalStyle />
              <Sprite />
              <Router history={history}>
                <Layout />
              </Router>
            </ThemeProvider>
          </StylesProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </AppProvider>
  )
}

export default App
